import { Pipe, PipeTransform } from '@angular/core';
import { arrayNotEmpty } from 'src/app/utils/array.utils';
import { MoteurRegleTypeDateRefDto } from 'src/graphql/generated-types';

@Pipe({
    name: 'needDaysInMonthFormId',
    standalone: false
})
export class NeedDaysInMonthFormIdPipe implements PipeTransform {

    transform(value: number, typeDateRefList: MoteurRegleTypeDateRefDto[]): boolean {
        return arrayNotEmpty(typeDateRefList) ? ['SAI', 'SAIINF'].includes(typeDateRefList.find(({Id}) => Id === value)?.Code) : false;
    }

}
